import React, { useRef } from 'react';

import Button from '@amzn/meridian/button';
import Menu, { MenuItem } from '@amzn/meridian/menu';

interface DownloadDropdownProps {
    showDropdown: boolean;
    setShowDropdown: (show: boolean) => void;
    isDataLoaded: boolean;
    rowDataLength: number;
    isDownloading: boolean;
    downloadingType: 'calculation' | 'royalty' | 'raw-calculation' | 'raw-royalty' | null;
    onDownloadCalculation: () => void;
    onDownloadRoyalty: () => void;
    onDownloadRawCalculation: () => void;
    onDownloadRawRoyalty: () => void;
}

export const DownloadDropdown: React.FC<DownloadDropdownProps> = ({
    showDropdown,
    setShowDropdown,
    isDataLoaded,
    rowDataLength,
    isDownloading,
    downloadingType,
    onDownloadCalculation,
    onDownloadRoyalty,
    onDownloadRawCalculation,
    onDownloadRawRoyalty
}) => {
    const buttonRef = useRef();

    const handleCalculationClick = () => {
        if (rowDataLength === 0 || isDownloading) return;
        setShowDropdown(false);
        onDownloadCalculation();
    };

    const handleRoyaltyClick = () => {
        if (isDownloading) return;
        setShowDropdown(false);
        onDownloadRoyalty();
    };

    const handleRawCalculationClick = () => {
        if (rowDataLength === 0 || isDownloading) return;
        setShowDropdown(false);
        onDownloadRawCalculation();
    };

    const handleRawRoyaltyClick = () => {
        if (isDownloading) return;
        setShowDropdown(false);
        onDownloadRawRoyalty();
    };

    const calculationText =
        isDownloading && downloadingType === 'calculation' ? 'Downloading...' : 'Territory Level (Current View)';

    const royaltyText =
        isDownloading && downloadingType === 'royalty' ? 'Downloading...' : 'Granular Level (Full Data)';

    const rawCalculationText =
        isDownloading && downloadingType === 'raw-calculation' ? 'Downloading...' : 'Territory Level (Current View)';

    const rawRoyaltyText =
        isDownloading && downloadingType === 'raw-royalty' ? 'Downloading...' : 'Granular Level (Full Data)';

    return (
        <>
            <Button
                ref={buttonRef}
                onClick={() => setShowDropdown(!showDropdown)}
                disabled={!isDataLoaded}
                type="tertiary"
            >
                Download CSV ▼
            </Button>
            <Menu
                open={showDropdown}
                onClose={() => setShowDropdown(false)}
                position="bottom"
                anchorNode={buttonRef.current}
            >
                <div style={{ padding: '8px 16px', fontWeight: 'bold', color: '#666', fontSize: '12px' }}>Compare</div>
                <MenuItem onClick={handleCalculationClick}>{calculationText}</MenuItem>
                <MenuItem onClick={handleRoyaltyClick}>{royaltyText}</MenuItem>
                <div
                    style={{
                        borderTop: '1px solid #ccc',
                        margin: '4px 0',
                        padding: '8px 16px',
                        fontWeight: 'bold',
                        color: '#666',
                        fontSize: '12px'
                    }}
                >
                    Raw
                </div>
                <MenuItem onClick={handleRawCalculationClick}>{rawCalculationText}</MenuItem>
                <MenuItem onClick={handleRawRoyaltyClick}>{rawRoyaltyText}</MenuItem>
            </Menu>
        </>
    );
};
